import { useState } from "react";
import { Link } from "react-router-dom";
import useAuthStore from "../store/authStore";
import CopyResumeLink from "./CopyResumeLink";
import { Link2 } from "lucide-react";

const DISMISS_KEY = "joborigo_resume_link_banner_dismissed";

export default function ResumeLinkBanner() {
  const seekerUser = useAuthStore((s) => s.seekerUser);
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(DISMISS_KEY) === "true"
  );

  if (dismissed || !seekerUser?.resume_slug) return null;

  const handleDismiss = () => {
    localStorage.setItem(DISMISS_KEY, "true");
    setDismissed(true);
  };

  return (
    <div className="mb-6 bg-brand-violet-tint dark:bg-brand-violet/10 border border-brand-violet/20 dark:border-brand-violet-on-dark/20 rounded-2xl px-5 py-4">
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-3">
          <Link2 className="w-5 h-5 flex-shrink-0 mt-0.5 text-brand-violet dark:text-brand-violet-on-dark" />
          <div>
            <p className="text-sm font-semibold text-gray-900 dark:text-white mb-1">
              Your general resume link
            </p>
            <p className="text-xs text-gray-500 dark:text-gray-400 leading-relaxed mb-3">
              Points at your primary resume and stays current as you update it.
              Use it in an email signature or a speculative approach. Applying
              for a specific role? Copy that resume's own link instead, so the
              employer sees the version you sent.{" "}
              <Link to="/how-it-works" className="text-brand-violet dark:text-brand-violet-on-dark hover:underline">
                Learn more →
              </Link>
            </p>
            <CopyResumeLink />
          </div>
        </div>
        <button
          onClick={handleDismiss}
          className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 flex-shrink-0 mt-0.5"
          aria-label="Dismiss"
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
}
